export const getStaticBaseURL = (url: string): string => {
  if (url.includes('stg-')) return 'https://stg-static.labpetz.com.br'
  if (url.includes('dev-') || url.includes('localhost'))
    return 'https://dev-static.labpetz.com.br'
  return 'https://static-file.petz.com.br'
}
